import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Container, Grid, type GridProps, Paper } from '@mui/material'
import { theme as newTheme } from 'styles/theme/hav-theme'

const TOPBAR_HEIGHT = '52px'
const SIDEBAR_WIDTH = '85px'
const SCROLLBAR_WIDTH = '20px'

interface GridStyled extends GridProps {
  // TODO: Replace with type string with boolean type
  fullwidth: 'true' | 'false'
}

export const PaperStyled = styled(Paper)`
  min-height: 100vh;
  background-color: ${newTheme.colors.quartenary};
  justify-content: center;
  display: flex;
  box-shadow: none;

  @media only screen and (max-width: ${newTheme.breakpoints.md}px) {
    :first-of-type {
      display: flex;
      align-items: center;
    }
  }
`

export const Main = styled('main')`
  margin-left: ${SIDEBAR_WIDTH};
  flex-grow: 1;
`

export const WrapContainerStyled = styled(Container)`
  ${({ header, fullwidth }: { header: number; fullwidth: 'true' | 'false' }) =>
    css`
      padding-top: ${header ? TOPBAR_HEIGHT : 0};

      @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
        padding-top: ${header ? TOPBAR_HEIGHT : 0};
      }
      @media (min-width: ${newTheme.breakpoints.xl}px) {
        max-width: ${fullwidth === 'true' ? '100vw' : '1440px'};
      }
    `}
`

export const GridContainerStyled = styled(Grid)`
  min-height: calc(100vh - ${TOPBAR_HEIGHT});
  justify-content: flex-start;

  @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
    min-height: 100vh;
  }
`

export const GridContentStyled = styled(Grid)<GridStyled>`
  max-width: ${({ fullwidth }) => (fullwidth ? '100%' : '1440px !important')};
  min-width: ${({ fullwidth }) => (fullwidth ? '100%' : '1440px')};
  margin: 0 auto;
  padding: ${({ fullwidth }) => (fullwidth ? `${newTheme.spacing.xm} ${newTheme.spacing.xm}` : 0)};

  @media only screen and (max-width: 1440px) {
    ${({ fullwidth }) =>
      fullwidth === 'false' &&
      css`
        max-width: 100vw !important;
        width: calc(100vw - ${SIDEBAR_WIDTH} - ${SCROLLBAR_WIDTH});
      `}
  }
`
